import {PermissionType} from '@hconnect/apiclient'
import {PageTitle} from '@hconnect/uikit/src/lib2'
import {Stack} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {useTranslationPrefix} from '../../shared/hooks'

import {PlantSelectBreadcrumb} from './PlantSelectBreadcrumb'

type SystemsEngineerDashboardTitleProps = {
  permission: PermissionType
}

export const SystemsEngineerDashboardTitle = ({permission}: SystemsEngineerDashboardTitleProps) => {
  const {t} = useTranslation()
  const {hrocPrefix} = useTranslationPrefix()

  return (
    <Stack>
      <PlantSelectBreadcrumb permission={permission} sx={{ml: 0}} />
      <PageTitle ml={0}>{t(`${hrocPrefix}.systemsEngineerDashboard.pageTitle`)}</PageTitle>
    </Stack>
  )
}
